/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteApiMacroprojectsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const deleteApiMacroprojectsId200Schema = z.any();

export const deleteApiMacroprojectsIdMutationResponseSchema = z.lazy(
  () => deleteApiMacroprojectsId200Schema,
);
